export const map = {
    components: {
        menu: require('components/menu/menu.desktop'),
        weezevent: require('components/weezevent/weezevent.desktop')
    },
    pages: {
        homepage: {
            index: require('pages/homepage/index.desktop')
        }
    }
};



// WEBPACK FOOTER //
// ./src/js/map/map.desktop.js